module.exports = __webpack_public_path__ + "img/cycling-aluno.8a8cd982.jpg";